import React from "react"
import { Link } from "react-router-dom"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons"

class GameCard extends React.Component{
    placeHolderImg = (e) =>{
        e.target.src = "/placeHolder.png"
    }
    getLabel = (isPrivate, isPublic, isOpenSource) => {
        if (isOpenSource) return 'open source';
        if (isPrivate) {
            return 'private';
        } else {
            return 'public';
        }
    }
    render(){
        const { id, imgUrl, gameName, gameAuthor, upvoteCount, isPrivate, isPublic, isOpenSource } = this.props
        const label = this.getLabel(isPrivate, isPublic, isOpenSource);
        return (
            <Link to={{
                pathname: "/arcade/game/" + id
            }}>
                <div className="gameCard fade-in">
                    <img onError={this.placeHolderImg} data-lazy={ imgUrl } className="gameImage" alt={gameName}/>
                    <div className="cardInfo">
                        <h2 className="gameTitle">{gameName}</h2>
                        <h4>Type: {label}</h4>
                        <h3 className="gameAuthor">made by <span className="authorName">{gameAuthor}</span></h3>
                        {upvoteCount === 0 
                        ? <div className="likePlaceHolder"></div>
                        : <><FontAwesomeIcon icon={faThumbsUp} />{upvoteCount}</>
                        }
                    </div>
                </div>
            </Link>
        )
    }
}

export default GameCard